'use strict';

export default class Contest {

    constructor() {
        let form = document.getElementById('contest-form');

        // is the element present on the current page
        if (!form) {
            return;
        }

        /* Add image to background on upload */
        $('input[type="file"]').change(function () {
            let file = this.files[0];
            let reader = new FileReader();
            reader.onloadend = function () {
                $('#contest_upload_image').children().hide();
                $('#contest_upload_image').css('background-image', 'url("' + reader.result + '")');
                ga('send', 'event', 'bih-photo-contest', 'picture-uploaded', 'webpage');
            }
            if (file) {
                reader.readAsDataURL(file);
            }
        });

        let input = form.querySelector('input[type="file"]'),
            label = form.querySelector('label'),
            submit = form.querySelector('#submitContestForm'),
            errorMsg = form.querySelector('.form-group__file .invalid-feedback'),
            // restart = form.querySelectorAll('.box__restart'),
            droppedFiles = false

        // letting the server side to know we are going to make an Ajax request
        var ajaxFlag = document.createElement('input');
        ajaxFlag.setAttribute('type', 'hidden');
        ajaxFlag.setAttribute('name', 'ajax');
        ajaxFlag.setAttribute('value', 1);
        form.appendChild(ajaxFlag);

        // drag&drop files if the feature is available
        if (this.isAdvancedUpload()) {
            form.classList.add('has-advanced-upload'); // letting the CSS part to know drag&drop is supported by the browser

            ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(event => {
                form.addEventListener(event, e => {
                    // preventing the unwanted behaviours
                    e.preventDefault();
                    e.stopPropagation();
                });
            });
            ['dragover', 'dragenter'].forEach(event => {
                form.addEventListener(event, () => {
                    form.classList.add('is-dragover');
                });
            });
            ['dragleave', 'dragend', 'drop'].forEach(event => {
                form.addEventListener(event, () => {
                    form.classList.remove('is-dragover');
                });
            });
            form.addEventListener('drop', e => {
                droppedFiles = e.dataTransfer.files;

                let file = droppedFiles[0];
                let reader = new FileReader();
                reader.onloadend = function () {
                    $('#contest_upload_image').children().hide();
                    $('#contest_upload_image').css('background-image', 'url("' + reader.result + '")');
                }
                if (file) {
                    reader.readAsDataURL(file);
                }
            });
        }

        // if the form was submitted
        form.addEventListener('submit', e => {

                if (!$('#contest-form')[0].checkValidity()) {

                    $('input').each(function () {

                        if (!this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            // Checkbox
                            $(this).siblings('.invalid-feedback').slideDown();

                            // Other elements
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                            $(this).siblings('.invalid-feedback').slideUp();
                        }
                    });

                    e.preventDefault();
                } else {
                    e.preventDefault();

                    ga('send', 'event', 'bih-photo-contest', 'form-sent', 'webpage');
                    var ajaxData = new FormData();
                    ajaxData.append(input.getAttribute('name'), input.files[0]);

                    if (droppedFiles) {
                        Array.prototype.forEach.call(droppedFiles, file => {
                            ajaxData.append(input.getAttribute('name'), file);
                        });
                    }

                    ajaxData.append('action', 'contest_form');
                    ajaxData.append('name', $('.form #name').val());
                    ajaxData.append('email', $('.form #email').val());
                    ajaxData.append('city', $('.form #city').val());
                    ajaxData.append('nonce', $('.form #nonce').val());

                    $.ajax({
                        url: '/wp/wp-admin/admin-ajax.php',
                        data: ajaxData,
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function (data) {
                            $('#start').hide();
                            // Hash photo ids so users cant guess random numbers md5
                            $('#uploaded-photo').attr('src', '/app/uploads/sites/6/photo-contest/' + data.image + '.jpg');
                            $('#about-contact-confirmation').show();
                            $('#upload-name').text($('.form #name').val());
                            ga('send', 'event', 'bih-photo-contest', 'form-success', 'webpage');

                            $([document.documentElement, document.body]).animate({
                                scrollTop: $('#about-contact-confirmation').offset().top
                            }, 1000);
                        },
                        error: function () {
                            $('.form-group__info--error').slideDown();
                            $('.form-group__file').addClass('has-errors');
                        }
                    });
                }
        });

        // Firefox focus bug fix for file input
        input.addEventListener('focus', () => {
            input.classList.add('has-focus');
        });
        input.addEventListener('blur', () => {
            input.classList.remove('has-focus');
        });

    }

    // feature detection for drag&drop upload
    isAdvancedUpload() {
        let div = document.createElement('div');
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    }
}
